import { render, staticRenderFns } from "./InviteErrorHandler.vue?vue&type=template&id=67fffa5a&"
import script from "./InviteErrorHandler.vue?vue&type=script&lang=js&"
export * from "./InviteErrorHandler.vue?vue&type=script&lang=js&"
import style0 from "./InviteErrorHandler.vue?vue&type=style&index=0&id=67fffa5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports